import { render, staticRenderFns } from "./CampanhaDetail.vue?vue&type=template&id=09f68afa&scoped=true&"
import script from "./CampanhaDetail.vue?vue&type=script&lang=js&"
export * from "./CampanhaDetail.vue?vue&type=script&lang=js&"
import style0 from "./CampanhaDetail.vue?vue&type=style&index=0&id=09f68afa&prod&scoped=true&lang=css&"
import style1 from "./CampanhaDetail.vue?vue&type=style&index=1&id=09f68afa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f68afa",
  null
  
)

export default component.exports